const tool = {
    // dataURL转换Blob对象
    dataURLtoBlob (dataurl) {
      var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr], {type: 'image/jpeg'})
    },

    // 秒转换时分秒
    secondToDate(result, type = 1) {
      var h = Math.floor(result / 3600)
      var m = Math.floor((result / 60 % 60))
      var s = Math.floor((result % 60))

      if (type === 1) {
        if (h > 0) {
          return result = `${h}时${m}分${s}秒`
        } else if (m > 0) {
          return result = `${m}分${s}秒`
        } else {
          return result = `${s}秒`
        }
      } else if (type === 2) {
        if (h > 0) {
          return result = `${h}:${m}:${s}`
        } else if (m > 0) {
          return result = `${m}:${s}`
        } else {
          return result = `${s}`
        }

      }
    },

    // 当前时间格式化
    getNowFormatDate() {
      var date = new Date()
      var seperator1 = "-"
      var seperator2 = ":"
      var month = date.getMonth() + 1
      var strDate = date.getDate()
      if (month >= 1 && month <= 9) {
        month = "0" + month
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate
      }
      var currentdate = date.getFullYear() + seperator1 + month + seperator1 + strDate
        + " " + date.getHours() + seperator2 + date.getMinutes()
        + seperator2 + date.getSeconds()
      return currentdate
    },

    // 找出数据元素的最大值
    getMaxInArr (arr) {
      let max = arr[0]
      for (var i = 0; i < arr.length; i++) {
        if (max < arr[i]) {
          max = arr[i]
        }
      }
      return max
    },

    //数组排序(内含对象的)
    // 0 小->大， 1 大->小
    sortByKey(arr, key, type){
      for (var i = 0; i < arr.length - 1; i++) {
        for (var j = 0; j < arr.length - 1 - i; j++) {
          if (type == 1) {
            if (Number(arr[j][key]) < Number(arr[j + 1][key])) {
              var temp = arr[j];
              arr[j] = arr[j + 1];
              arr[j + 1] = temp;
            }
          } else {
            if (Number(arr[j][key]) > Number(arr[j + 1][key])) {
              var temp = arr[j];
              arr[j] = arr[j + 1];
              arr[j + 1] = temp;
            }
          }
        }
      }
      return arr
    },

    //普通数字转千分符分割数字
    thousandSeparator(num){
      var result = '', counter = 0;
      num = (num || 0).toString();
      for (var i = num.length - 1; i >= 0; i--) {
        counter++;
        result = num.charAt(i) + result;
        if (!(counter % 3) && i != 0) {
          result = ',' + result;
        }
      }
      return result
    },

    // 判断浏览器类型
    userBrowser() {
      var browserName=navigator.userAgent.toLowerCase()
      if(/msie/i.test(browserName) && !/opera/.test(browserName)){
        return 'ie'
      }else if(/MicroMessenger/i.test(browserName)){
        return 'wechat';
      }else if(/firefox/i.test(browserName)){
        return 'firefox'
      }else if(/chrome/i.test(browserName) && /webkit/i.test(browserName) && /mozilla/i.test(browserName)){
        return 'chrome'
      }else if(/opera/i.test(browserName)){
        return 'opera'
      }else if(/webkit/i.test(browserName) &&!(/chrome/i.test(browserName) && /webkit/i.test(browserName) && /mozilla/i.test(browserName))){
        return 'safari'
      }else{
        return 'unknow'
      }
    }
  }

  export default tool


// WEBPACK FOOTER //
// ./src/utils/tool.js